module.exports = __webpack_public_path__ + "img/file-download-black-24-dp.4eb0c1dc.svg";